import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import moment from 'moment';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

const getDriverRestrictions = (props) => {
    const { driverOption, driverDob, youngerDriverDob } = props;
    if (isYoungerThan21(driverDob) || isYoungerThan21(youngerDriverDob)) {
        return null;
    }

    return getRestrictionsLabel(driverOption);
};

const isYoungerThan21 = (dob) => moment().tz('Australia/Brisbane').diff(dob, 'years', true) < 21;

export const getRestrictionsLabel = (value) => ({
    DRIVERS_21_AND_OVER: 'Yes, all drivers will be 21 & over',
    DRIVERS_25_AND_OVER: 'Yes, all drivers will be 25 & over',
    DRIVERS_30_AND_OVER: 'Yes, all drivers will be 30 & over',
    DRIVERS_40_AND_OVER: 'Yes, all drivers will be 40 & over',
    DRIVERS_50_AND_OVER: 'Yes, all drivers will be 50 & over',
    NO_RESTRICTION: 'No restrictions'
}[value]);

const _DriverRestrictions = (props) => {
    return (
        <QuoteCard title="Driver restrictions" path="driver_option">
            <QuoteQuestionPlainItem title="Driver restrictions" content={getDriverRestrictions(props)} />
        </QuoteCard>
    );
};

_DriverRestrictions.propTypes = {
    driverOption: PropTypes.string,
    youngerDriverDob: PropTypes.string,
    driverDob: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        driverOption: quoteFormSelector(state).getIn(['coverDetail', 'driverOption']),
        youngerDriverDob: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'dob']) || '',
        driverDob: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'dob'])
    };
};

const DriverRestrictions = connect(mapStateToProps)(_DriverRestrictions);

export { DriverRestrictions, _DriverRestrictions };
